"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericErrorMessage = exports.reconnectionErrorMessage = exports.NewProject = void 0;
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var reconnectionErrorMessage = "We had trouble connecting to your HubSpot account. Please reconnect HubSpot from Qwilr integrations page.";
exports.reconnectionErrorMessage = reconnectionErrorMessage;
var genericErrorMessage = "Qwilr creation failed. Please try again.";
exports.genericErrorMessage = genericErrorMessage;
var NewProject = (function (_super) {
    __extends(NewProject, _super);
    function NewProject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderUseButton = function () {
            var _a = _this.props, createQwilr = _a.createQwilr, isCreationDisabled = _a.isCreationDisabled;
            return (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, onClick: createQwilr, disabled: isCreationDisabled }, "Use template"));
        };
        _this.renderTemplates = function () {
            var templatesList = _this.props.templates.map(function (template, index) {
                return _this.renderTemplate(template, index);
            });
            return react_1.default.createElement("div", { className: "templates" }, templatesList);
        };
        _this.renderTemplate = function (template, index) {
            var onTemplateSelect = _this.props.onTemplateSelect;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)("template", { selected: template.selected }), onClick: function () { return onTemplateSelect(template); }, key: index }, template.name));
        };
        _this.maybeRenderError = function () {
            var _a = _this.props, isFailed = _a.isFailed, shouldReconnect = _a.shouldReconnect;
            if (isFailed) {
                if (shouldReconnect) {
                    return react_1.default.createElement("div", { className: "message error" }, reconnectionErrorMessage);
                }
                else {
                    return react_1.default.createElement("div", { className: "message error" }, genericErrorMessage);
                }
            }
            else {
                return null;
            }
        };
        return _this;
    }
    NewProject.prototype.render = function () {
        var _a = this.props, onFilter = _a.onFilter, filterValue = _a.filterValue, onFilterClear = _a.onFilterClear;
        return (react_1.default.createElement("div", { className: "hubspot" },
            react_1.default.createElement("div", { className: "new-project" },
                react_1.default.createElement("section", { className: "header" },
                    react_1.default.createElement("div", { className: "branding" },
                        react_1.default.createElement("img", { src: "/Assets/icons/QwilrLogo.svg", className: "logo" }),
                        react_1.default.createElement("div", { className: "text" },
                            "Powered by ",
                            react_1.default.createElement("b", null, "Qwilr"))),
                    this.renderUseButton()),
                react_1.default.createElement("section", { className: "content" },
                    react_1.default.createElement("div", { className: "template-header" }, "Choose a template"),
                    react_1.default.createElement(kaleidoscope_1.SearchInput, { label: "Find template", value: filterValue, placeholder: "Find Template", onChange: onFilter, onClear: onFilterClear }),
                    this.renderTemplates()),
                react_1.default.createElement("section", { className: "result" }, this.maybeRenderError()))));
    };
    NewProject = __decorate([
        mobx_react_1.observer
    ], NewProject);
    return NewProject;
}(react_1.default.Component));
exports.NewProject = NewProject;
